<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <v-container
    :class="!$vuetify.breakpoint.lgAndUp ? 'px-4' : 'px-6'"
    class="text-body-2"
    style="position: relative"
  >
    <ik-data-table
      ref="dataTable"
      :filter="filter"
      :model="DishesConsumeType"
      :use-add-action="false"
      :use-delete-action="false"
      :use-edit-action="false"
      entity-name="ProductVisibility"
      icon="mdi-chart-bubble"
    >
      <template #navigation>
        <back-button @close-event="$emit('close')" />
      </template>
    </ik-data-table>
  </v-container>
</template>

<script>
import DishesConsumeType from '@/model/dataLayer/api/buffet/DishesConsumeType'
import BackButton from '@/views/widget/uiComponent/BackButton.vue'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'

export default {
  name: 'ShowDishCard',
  components: {
    BackButton,
    IkDataTable
  },
  props: {
    close: {},
    filter: {}
  },
  data () {
    return {
      DishesConsumeType,
      closeDialog: this.close
    }
  },
  mounted () {
    this.$refs.dataTable.reload()
  }
}
</script>

<style scoped>

</style>
